var CATEGORIES = [
    // Hero
    {
      name: "hero",
      label: "Hero",
    },
    // Inner Page Hero
    {
      name: "inner-page-hero",
      label: "Inner Page Hero",
    },
    // services
    {
      name: "services",
      label: "Services",
    },
    // steps
    {
      name: "steps",
      label: "Steps",
    },
    // about
    {
      name: "about",
      label: "About",
    },
    // stats
    {
      name: "stats",
      label: "Stats",
    },
    // logos
    {
      name: "logos",
      label: "Logos",
    },
    // text
    {
      name: "text",
      label: "Text",
    },
    // list
    {
      name: "list",
      label: "List",
    },
    // team
    {
      name: "team",
      label: "Team",
    },
    // restruant menu
    {
      name: "restruant-menu",
      label: "Restruant Menu",
    },
    // testimonials
    {
      name: "testimonials",
      label: "Testimonials",
    },
    // contact us
    {
      name: "contact-us",
      label: "Contact Us",
    },
    // service areas
    {
      name: "service-areas",
      label: "Service Areas",
    },
    // portfolio
    {
      name: "portfolio",
      label: "Portfolio",
    },
    // cta
    {
      name: "cta",
      label: "CTA",
    },
    // gallery
    {
      name: "gallery",
      label: "Gallery",
    },
    // events
    {
      name: "events",
      label: "Events",
    },
    // faq
    {
      name: "faq",
      label: "FAQ",
    },
    // property listing
    {
      name: "property-listing",
      label: "Property Listing",
    },
    // pricing
    {
      name: "pricing",
      label: "Pricing",
    },
    // e-commerce
    {
      name: "e-commerce",
      label: "E-commerce",
    },
    {
        name: "footer",
        label: "Footer",
    },
  ]

  export default CATEGORIES;